export default "__VITE_ASSET__jGXLvfqf__"